<template>
  <div
    class="super-tree-preview"
    :class="[`size-${size}`]"
    ref="superTreePreview"
  >
    <span class="item" v-for="(item, index) in __selected" :key="item.value">
      <span class="text">{{ item.label }}</span>
      <Icon
        class="delete-btn"
        type="md-close"
        @click.stop="deleteItem(index)"
      ></Icon>
    </span>
  </div>
</template>

<script>
export default {
  name: "SuperTreePreview",
  props: {
    size: {
      type: String,
      default: "default",
    },
    value: Array,
  },
  data() {
    return {
      mo: null,
      oldHeight: 32,
    };
  },
  computed: {
    __selected() {
      return JSON.parse(JSON.stringify(this.value));
    },
  },
  mounted() {
    this.mo = new MutationObserver(this.onResize);
    this.mo.observe(this.$refs.superTreePreview, {
      childList: true,
    });
  },
  beforeDestroy() {
    this.mo.disconnect();
  },
  methods: {
    deleteItem(index) {
      this.__selected.splice(index, 1);
      this.$emit("input", this.__selected);
      this.$emit("on-change", this.__selected);
    },
    onResize() {
      const newHeight = this.$refs.superTreePreview.offsetHeight;
      if (newHeight !== this.oldHeight) {
        const diff = newHeight - this.oldHeight;
        const selectDrop = document.querySelector(".super-tree-dropdown");
        const newTop =
          Number(selectDrop.style.top.replace("px", "")) + diff + "px";
        selectDrop.style.top = newTop;
        this.oldHeight = newHeight;
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.super-tree-preview
  display block
  box-sizing border-box
  outline none
  user-select none
  cursor pointer
  position relative
  background-color #fff
  border-radius 4px
  border 1px solid #dcdee2
  transition all .2s ease-in-out
  width 100%
  padding 0 5px 3px 5px

  &:hover
    border-color #57a3f3

  &.size-default
    min-height 32px

    .selected-item
      height 22px
      line-height 22px
      margin 3px 4px 2px 0

  .item
    position relative
    display inline-flex
    align-items center
    border 1px solid #e8eaec
    border-radius 3px
    background #f7f7f7
    font-size 12px
    height 26px
    padding 0px 20px 0px 8px
    margin 3px 5px 0 0

    .delete-btn
      position absolute
      right 4px
</style>
